const VERIFIER_KEY = "dayvise.pkce.verifier";
const STATE_KEY = "dayvise.pkce.state";

type PendingStorage = Pick<Storage, "getItem" | "setItem" | "removeItem">;

export function clearPendingSignIn(storage: PendingStorage): void {
  storage.removeItem(VERIFIER_KEY);
  storage.removeItem(STATE_KEY);
}

export function savePendingSignIn(storage: PendingStorage, verifier: string, callbackState: string): void {
  if (!verifier || !callbackState) throw new Error("The API returned an incomplete sign-in response. Start again.");
  clearPendingSignIn(storage);
  storage.setItem(VERIFIER_KEY, verifier);
  storage.setItem(STATE_KEY, callbackState);
}

/** A returned code must belong to the sign-in started in this browser tab. */
export function requireSignInVerifier(storage: PendingStorage, callbackState: string | null): string {
  const verifier = storage.getItem(VERIFIER_KEY);
  const expectedState = storage.getItem(STATE_KEY);
  if (!verifier || !expectedState || !callbackState || callbackState !== expectedState) {
    throw new Error("This sign-in does not match the request started in this browser. Start again.");
  }
  return verifier;
}
